<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.contract_no" clearable placeholder="合同号"></el-input>
                <!-- <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.customer_id" clearable placeholder="客户" @visible-change="getCustomerList">
                    <el-option v-for="list in customerList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="search">查询</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .filter_path{
            padding: 15px; background-color: #F4F5F9;
            .filter_input{
                width: 120px;
                & + .filter_input{ margin-left: 34px; }
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
        }
        .table_path{ flex: 1; }
    }
</style>
<script>
    import pagination from '../../../components/pagination.vue'
    import tabletem from '../../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                start_time:"",
                end_time:new Date(),
                params : {
                    start_time:"",
                    end_time:"",
                    contract_no : "",
                    customer_id : "",
                    per_page : 50,
                    page : 1
                },
                last_page : 1,
                current_page : 1,
                total : 0,

                customerList : [],
                statistics : {},
                list : [],
                tableCol : [
                    {colName : "合同号",colKey:"contract_no",colWidth:190,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName : "合同日期",colKey:"contract_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName : "品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName : "合同立方",colKey:"contract_cube",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName : "入库码单立方",colKey:"storage_cube",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName : "销售出库立方",colKey:"sale_out_cube",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName : "销售金额",colKey:"sales_amount",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName : "剩余码单立方",colKey:"sub_cube",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true}
                ]
            }
        },
        created(){
            this.getList();
        },
        methods:{
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.tableLoading = true;
                this.postFunc("/erp/purchase.analysis",this.params,response=>{
                    if(response.data.code == 0){
                        let list = response.data.data.data
                        list.forEach((item) => {
                            item.contract_time =  window.moment( Number(item.contract_time) * 1000 ).format("YYYY-MM-DD")
                        })
                        this.list = list;
                        this.total = response.data.data.total;
                        this.last_page = response.data.data.last_page;
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            search(){
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                this.start_time = "";
                this.end_time = new Date();
                this.params = {
                    start_time:"",
                    end_time:"",
                    contract_no : "",
                    customer_id : "",
                    per_page : 50,
                    page : 1
                }
                this.getList()
            },

            // 获取客户
            getCustomerList(visible){
                if(visible){
                    this.$getCustomerList().then(res=>{
                        this.customerList = res.data.data;
                    })
                }
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
